import { getAllPosts } from '../blog/posts';
import { legacyPosts } from '../blog/legacyPosts';

export interface PostSummary {
  slug: string;
  title: string;
  cover?: string;
  tags: string[];
}

const summaries: PostSummary[] = [
  ...legacyPosts.map((post) => ({ slug: post.slug, title: post.title, cover: post.cover, tags: post.tags })),
  ...getAllPosts().map((post) => ({ slug: post.slug, title: post.title, cover: post.cover, tags: post.tags })),
];

export function findPost(slug: string): PostSummary | undefined {
  return summaries.find((post) => post.slug === slug);
}

export function postsTagged(tag: string): PostSummary[] {
  return summaries.filter((post) => post.tags.includes(tag));
}
